module.exports = __webpack_public_path__ + "img/money-mouth-face.f482c011.png";